import React from 'react';
import { Box } from '@mui/material';
import Markdown from './Markdown';
import { logger } from '../logger';

const ChatContainer = ({ messages, isLoading, chatContainerRef, setInput }) => {
  const renderMessage = (message) => {
    if (message.type === 'user') {
      return (
        <div key={message.id} className="message user-message">
          <div className="message-content user-content">
            {message.content}
          </div>
          <div className="message-time">{new Date(message.timestamp).toLocaleTimeString()}</div>
        </div>
      );
    }
    
    if (message.type === 'bot') {
      const response = message.content;
      return (
        <div key={message.id} className="message bot-message">
          <div className="message-content bot-content">
            {response.prelude && (
              <div className="response-prelude">
                <Markdown text={response.prelude} />
              </div>
            )}
            
            {response.answer && response.answer.length > 0 && (
              <div className="response-answers">
                {response.answer.map((item, index) => (
                  <div key={index} className="answer-item">
                    <h3 className="answer-heading">{item.heading}</h3>
                    <Markdown text={item.content} />
                    {item.citation && (
                      <div className="answer-citation">Source: {item.citation}</div>
                    )} 
                  </div>
                ))}
              </div>
            )}
            
            {response.Suggestions && response.Suggestions.length > 0 && (
              <div className="response-suggestions">
                <h4>Related Questions:</h4>
                <ul>
                  {response.Suggestions.map((suggestion, index) => (
                    <li key={index} className="suggestion-item" onClick={() => setInput(suggestion)}>
                      {suggestion}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="message-time">{new Date(message.timestamp).toLocaleTimeString()}</div>
        </div>
      );
    }
    
    if (message.type === 'error') {
      return (
        <div key={message.id} className="message error-message">
          <div className="message-content error-content">
            {message.content}
          </div>
          <div className="message-time">{new Date(message.timestamp).toLocaleTimeString()}</div>
        </div>
      );
    }
  };

  return (
    <Box
      className="chat-container"
      ref={chatContainerRef}
      sx={{
        flex: 1,
        minHeight: 0,                  // allow proper flexbox scrolling
        overflowY: 'auto',
        pt: { xs: 1, md: 2 },
        px: { xs: 2, md: 3 },
        pb: { xs: 1, md: 1 },
      }}
    >
      <Box
        className="chat-messages"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 1.5, md: 2 },
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          p: 0,
          maxWidth: 'none',
          mx: 0,
        }}
      >
        {messages.map(renderMessage)}
        {isLoading && (
          <div className="message bot-message loading">
            <div className="message-content bot-content">
              <div className="loading-spinner"></div>
              <span>Thinking...</span>
            </div>
            {logger.debug('[ChatContainer] showing loading spinner')}
          </div>
        )}
      </Box>
    </Box>
  );
};

export default ChatContainer;
